module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ls-cddead61f832a10065e915b2c41e04d6.svg";